import {
  CREATE_AD_CAMPAIGN_START,
  CREATE_AD_CAMPAIGN_SUCCESS,
  CREATE_AD_CAMPAIGN_FAILED,
  FETCH_USER_AD_START,
  FETCH_USER_AD_SUCCESS,
  FETCH_USER_AD_FAILED,
  FETCH_USER_AD_START_BY_ID,
  FETCH_USER_AD_SUCCESS_BY_ID,
  FETCH_USER_AD_FAILED_BY_ID,
  FETCH_RECOMMENDED_AD_FOR_USER_SUCCESS,
  FETCH_RECOMMENDED_AD_FOR_USER_FAILED,
  FETCH_RECOMMENDED_AD_FOR_USER_START,
  PUBLISH_USER_AD_BY_ID_SUCCESS,
  PUBLISH_USER_AD_BY_ID_START,
  PUBLISH_USER_AD_BY_ID_FAILED,
  DELETE_USER_AD_BY_ID_START,
  DELETE_USER_AD_BY_ID_SUCCESS,
  DELETE_USER_AD_BY_ID_FAILED,

} from "../actions/ActionConstant";

export const initialState = {
  ads: {
    data: [],
    loading: false,
    error: false,
    inputData: {},
  },
  recommendedAd: {
    recommendedData: [],
    loading: false,
    error: false
  }
};

const adsReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_AD_CAMPAIGN_START:
      // Action for starting Create Ads
      return {
        ...state,
        ads: {
          ...state.ads,
          data: {},
          error: false,
          loading: true,
          inputData: action.payload.payload,
        },
      };

    // Action for successfully Create Ads
    case CREATE_AD_CAMPAIGN_SUCCESS:
      return {
        ...state,
        ads: {
          ...state.ads,
          data: [action.payload],
          error: false,
          loading: false,
          inputData: {},
        },
      };

    // Action for failing to Create Ads
    case CREATE_AD_CAMPAIGN_FAILED:
      return {
        ...state,
        ads: {
          ...state.ads,
          loading: false,
          inputData: {},
          error: action.error,
        },
      };

    case FETCH_USER_AD_START:
      return {
        ...state,
        ads: {
          ...state.ads,
          loading: true,
          error: false,
        },
      };

    case FETCH_USER_AD_SUCCESS:
      return {
        ...state,
        ads: {
          ...state.ads,
          data: action.payload,
          loading: false,
          error: false,
        },
      };

    case FETCH_USER_AD_FAILED:
      return {
        ...state,
        ads: {
          ...state.ads,
          data: [],
          loading: false,
          error: action.error,
        },
      };

    case FETCH_USER_AD_START_BY_ID:
      return {
        ...state,
        ads: {
          ...state.ads,
          loading: true,
          error: false,
        },
      };

    case FETCH_USER_AD_SUCCESS_BY_ID:
      return {
        ...state,
        ads: {
          ...state.ads,
          data: action.payload,
          loading: false,
          error: false,
        },
      };

    case FETCH_USER_AD_FAILED_BY_ID:
      return {
        ...state,
        ads: {
          ...state.ads,
          data: [],
          loading: false,
          error: action.error,
        },
      };

    case FETCH_RECOMMENDED_AD_FOR_USER_START:
      return {
        ...state,
        recommendedAd: {
          ...state.recommendedAd,
          loading: true,
          error: false,
        },
      };

    case FETCH_RECOMMENDED_AD_FOR_USER_SUCCESS:
      return {
        ...state,
        recommendedAd: {
          ...state.recommendedAd,
          recommendedData: action.payload[0] ? [...state.recommendedAd.recommendedData, action.payload[0]] : state.recommendedAd.recommendedData,
          loading: false,
          error: false,
        },
      };

    case FETCH_RECOMMENDED_AD_FOR_USER_FAILED:
      return {
        ...state,
        recommendedAd: {
          ...state.recommendedAd,
          recommendedData: [],
          loading: false,
          error: action.error,
        },
      };

    case PUBLISH_USER_AD_BY_ID_START:
      return {
        ...state,
        ads: {
          ...state.ads,
          error: false,
        },
      };

    case PUBLISH_USER_AD_BY_ID_SUCCESS:
      return {
        ...state,
        ads: {
          ...state.ads,
          data: action.payload,
          loading: false,
          error: false,
        },
      };

    case PUBLISH_USER_AD_BY_ID_FAILED:
      return {
        ...state,
        ads: {
          ...state.ads,
          loading: false,
          error: action.error,
        },
      };

    case DELETE_USER_AD_BY_ID_START:
      return {
        ...state,
        ads: {
          ...state.ads,
          error: false,
        },
      };

    case DELETE_USER_AD_BY_ID_SUCCESS:
      return {
        ...state,
        ads: {
          ...state.ads,
          loading: false,
          error: false,
        },
      };

    case DELETE_USER_AD_BY_ID_FAILED:
      return {
        ...state,
        ads: {
          ...state.ads,
          loading: false,
          error: action.error,
        },
      };

    default:
      return state;
  }
};

export default adsReducer;
